import _ from 'lodash'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import App from './App.vue'
import store from '@/vuex/store'
import Settings from '@/config/Settings'
import { mappingRoutes } from '@/Route.js'
import Translation from '@/core/mixins/Translation'
import Utils from '@/core/mixins/Utils'
import isMobile from 'ismobilejs'
// import axios from 'axios'
// import VueAxios from 'vue-axios'

import LangMixin from '@/core/mixins/Lang'
import VueClipboard from 'vue-clipboard2'
import '@/core/js/Copyright'

import 'gsap-babylon-plugin'
import gsap from "gsap"

// Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.use(Meta,{ keyName: 'head' })
Vue.mixin(Translation)
Vue.mixin(Utils)
Vue.use(VueClipboard)
Vue.config.productionTip = false

const routes = [
    { id: 'welcome', name: 'welcome', component: 'Experience', fr: 'bienvenue', en: '' },
]

const router = new VueRouter({
    mode: 'history',
    routes: mappingRoutes(routes)
})

window.EventBus = new Vue({
  methods: {
    emit(data) {
        this.$emit('$EventBusEvent', data)
    }
  }
})

new Vue({
    router,
    store,
    mixins: [ LangMixin ],
    head() {
        return {
            htmlAttrs: { lang: this.lang },
            title: 'Compagnie Blasco',
            titleTemplate: '%s | Rugby and Co'
      }
    },
    data: () => ({
        world: null
    }),
    computed: {
        route() { 
            return this.$store.getters['app/route'] 
        }
    },
    beforeCreate() {
        this.$store.commit('app/LANG_CHANGED', this.$route.meta.lang)
        this.$store.commit('app/SET_FROM_ROUTE', this.$route)
        this.$store.commit('app/SET_TO_ROUTE', this.$route)
    },
    created() {  
        // 
    },
    mounted() {
        this.isPhone = isMobile(window.navigator).phone
    },
    render: h => h(App)
}).$mount('#app')


